import { takeEvery, fork, put, all, call } from "redux-saga/effects"
import toastr from "toastr"
import i18n from "i18n"
import { API } from "api"
import { translationRemove } from "./slice"

function* remove({ payload: { id, onSuccess } }) {
  try {
    const response = yield call(API.translation.removeTranslation, id)

    const { data } = response

    if (onSuccess) {
      onSuccess()
    }
    toastr.success(i18n.t("removed_success"))
    yield put(translationRemove.removeCompleted())
  } catch (error) {
    const errors = error.response?.data?.errors || {}
    const message = error.response?.data?.message || i18n.t("error")

    yield put(
      translationRemove.removeRejected({
        errors,
        message,
      })
    )
    toastr.error(message)
  }
}

export function* watchRemove() {
  yield takeEvery(translationRemove.remove, remove)
}

function* removeSaga() {
  yield all([fork(watchRemove)])
}

export default removeSaga
